import { deleteUserApi, getAllUsersApi } from '../api/userApi';

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const DELETE_USER_REQUEST = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';
export const SET_PAGE = 'SET_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const MARK_MUTATION_IDLE = 'MARK_MUTATION_IDLE';

export const fetchUsers = (page, pageSize) => async (dispatch) => {
  dispatch({ type: FETCH_USERS_REQUEST });

  try {
    const response = await getAllUsersApi({ page, pageSize });
    dispatch({
      type: FETCH_USERS_SUCCESS,
      payload: {
        users: response.data.users,
        totalUsers: response.data.totalUsers,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_USERS_FAILURE,
      payload: error.message,
    });
  }
};

export const setPage = (page) => ({
  type: SET_PAGE,
  payload: page,
});

export const setPageSize = (pageSize) => ({
  type: SET_PAGE_SIZE,
  payload: pageSize,
});

export const markMutationAsIdle = () => ({
  type: MARK_MUTATION_IDLE,
});

export const deleteUser = (userId) => async (dispatch) => {
  dispatch({ type: DELETE_USER_REQUEST });
  try {
    await deleteUserApi(userId);
    dispatch({
      type: DELETE_USER_SUCCESS,
    });
  } catch (err) {
    dispatch({
      type: DELETE_USER_FAILURE,
      payload: err.message,
    });
  }
};
